import React from 'react';

const TYPE_ORDER = ['battle', 'planeswalker', 'creature', 'sorcery', 'instant', 'artifact', 'enchantment', 'land'];

const primaryType = (types) => {
    if (!types) return null;
    const beforeDash = types.split('—')[0].trim();
    return TYPE_ORDER.find((t) => beforeDash.includes(t)) || null;
};

export function CardTypeIcon({ types }) {
    const type = primaryType(types);
    if (!type) {
        return <div className="cardTypeIconPlaceholder" />;
    }
    return (
        <img
            src={`/resources/typeIcons/${type}_symbol.svg`}
            aria-label={type}
            title={type}
            className="cardTypeIcon"
        />
    );
}
